import React, { useState, useEffect } from "react";
import {
  Bot,
  Zap,
  Globe,
  Layers,
  ShieldCheck,
  TrendingUp,
  Cpu,
  Menu,
  X,
  ChevronDown,
  ChevronUp,
  Twitter,
  Send,
  ArrowRight,
  Database,
  Code,
  Activity,
  Rocket,
  Info,
} from "lucide-react";

// --- Components ---

const Logo = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="text-mint-400 animate-float"
  >
    <path
      fill="currentColor"
      d="M66,92.4c-18.6,2.7-8.9,32.7,7.9,22.8s4.7-24.6-7.9-22.8ZM425.4,92.4c-17.8,3.7-8.1,32.7,8.9,22.7,11.6-6.8,4.3-25.5-8.9-22.7ZM201.4,185.2c4,3.5,9.6,6.2,14.9,6.8,15.2,1.5,46.6,1.4,61.9,0,16.5-1.4,16.1-12.2,27.4-16,2.1-.7,5.6-.2,6.8-1.5,1.2-5.4,13.1-42.3,12-44.4-1.7-3.4-27.9-11.1-33-12.3-33-7.7-68.7-6.1-101,4s-18.2,6.1-18.8,8-.2,1.7,0,2.5l11.5,42.2c3.2,1.7,6.9,1.1,10.2,2.7s5.5,5.8,8.1,8ZM72.7,128.2c-2.9-.1-3-.5-2.8,2.3,1.9,25.3,4.2,50.6,6.5,75.8.7,7.4,0,15.3,2.3,22.6,1.8-2.2,8.1-2.8,9.2-4.6s2.2-10.3,2.1-11.6l-17.4-84.5ZM425.6,128.2h-2.8s-17.2,83.7-17.2,83.7c1.4,9.8.8,15.7,12.6,16l7.4-99.8ZM379.1,369.9c19.2-19.5,19.8-47.1,20.7-73.1,1.1-31.1.5-71.3-10.4-100.5s-29.6-48.7-54.3-60.7l-11.1,42.4c20.4,5.2,36.1,18,44.5,37.3,12.1,28.2,12.6,77.6,4,106.9-7.3,24.9-25.5,43.9-50.2,51.9l-3.8,24.8c21.1-3.9,45.4-13.4,60.6-29ZM160.5,136.5c-1.6-1.1-14.3,8-16.5,9.8-30.3,23.5-42.9,55.8-46.3,93.2-2.5,28-4,92.5,9.1,116.5,13.5,24.7,44.2,37,70.4,42.8l-4.5-24.3c-31.7-12.3-48.7-37.3-53.5-70.5-5.6-38.3-3-97.1,34.4-118.8,2.7-1.6,16.8-6.9,17.1-7.8,2-5.7-9.2-33.2-10-41ZM182.4,187.6c-48.7,5.1-55.6,58.5-53.4,98.1,3.3,57.8,29.3,79.6,85.4,85.5,42.5,4.4,116,4.8,140.3-37,17-29.2,17.4-106.6-8.2-131.1-7.4-7.1-26.8-16.6-37-15.8s-4.9,4.3-7.4,6.5c-5.9,5.2-14.4,9.2-22.3,10.1-15.3,1.6-47.3,1.5-62.7,0-5.6-.5-14.6-3.4-19.3-6.6s-8.9-9.6-9.5-9.9c-1.8-.6-4.2,0-6.1.1ZM86.6,238.2c-7.2.8-12.8,7.1-15.9,13.2-8.6,17.3-8.1,60.5,8.6,73.1,6.9,5.2,7.8,5.1,7.3-3.7-.3-6.7-1.7-14.5-1.9-21.2-.7-20.5,0-41.2,1.9-61.5ZM409,327.8c1.1,1.2,6.7-2.8,7.8-3.7,14.7-11.8,15.4-43.1,12.2-60.2-2-10.5-7.4-22.7-18.6-25.7-.2,21,.9,42.2.5,63.3l-1.9,26.3ZM310.1,378.6c-33.6,6.1-68.8,7.7-102.9,3.6-4.4-.5-16.6-3.9-19.5-3.6s-1.4.2-1.9.9c-1,1.4,3.5,18.6,4.9,21s.8,1.5,2.1,1.7c25.7,4,53.1,5.6,79.1,4.2,4.3-.2,30.9-3.2,32.5-4.9s6.6-22.1,5.7-22.9ZM134.2,396.3c-.9,0-4.4-2-6-2.9s-1.8-1.2-2.8-1.8c-13-8.5-22.4-18.1-29.7-31.8s-.4-2.9-2.6-2.4c-.2-.7.1-1.9,0-2.8s-.5-.8-.9-.9c-.1-.6.1-1.4,0-1.8-.8-2.7-2.6-10.2-4.6-11.1s-5.2-.6-7.9-1.8c-4.6-2-8.1-5.8-11.5-9.3s-2.4-2.3-2.8-2.8c-2.4-3.1-4-5.5-5.5-9.2-2.5-6.3-4.7-16.3-5.5-23.1s0-1.9,0-2.8c-.7-8,.1-14.7,0-22.2s0-1.2,0-1.8c1.3-.5.8-1.8.9-2.8s-.1-1.3,0-1.8c1.6-8.6,4.9-16.6,9.2-24,.3-.3.6-.7.9-.9,3.8-3.1,1.3-9.4.9-13.9s0-1.9,0-2.8v-.9c-.2-2.3-.7-4.8-.9-7.4s-.6-7.4-.9-11.1,0-1.9,0-2.8l-.9-2.8c-.1-1.8.1-3.7,0-5.5-.3-3.7-.6-7.4-.9-11.1s0-1.9,0-2.8c0-1.5.6-3.8-.9-4.6-1.2-14.8-1.6-29.8-2.8-44.6-6.2-5.6-11.4-8.8-13.8-17.3l-.9-1.8c0-.3,0-.6,0-.9-1-16.2,11.6-28.9,27.9-26.5,10.5,1.5,16.6,10.5,19.2,20.1-.1.6,0,1.3,0,1.8-.6,3.3-.4,6.4-1.7,9.9s-6.4,8.2-6.7,10c-.6,3.5,1.5,5.5,1.9,7.8s-.1,1.3,0,1.8c3.6,18.8,8.4,37.4,11.1,56.4,2.1.4,1.5-.1,2.1-1.2,1.6-2.9,2.8-7.8,4.4-10.8s3.4-6.4,4.6-8.3c12.7-19.7,28.4-29.8,46.2-43.4,8.8-3.6,16.9-8.7,25.9-12,9-3.4,18.6-5.2,27.7-8.3.6,0,1.2,0,1.8,0l24-3.7c.9,0,1.9,0,2.8,0,5.2.3,10.5-.2,15.7,0s4.9-.1,7.4,0c27.2,1.3,56.6,8.9,80.4,22.2s5.8,2.7,7.4,3.7c7.8,4.9,20.1,15.4,26.8,22.2.3.3.6.6.9.9l1.8,1.8c1.3,1.4,3.2,3.9,4.6,5.5s2.6,4.2,4.6,5.5c.2,1.3.8,1.5.9,1.8s.8.6.9.9c.3.6.6,1.2.9,1.8,3.6,6.9,7.8,13.5,11.6,20.3,1.5-2.8.9-6.3,1.4-9.2s.6-4,.9-5.5.6-.4.9-1.8-.1-1.3,0-1.8c.8-4,1.9-7.7,2.8-12s0-.6,0-.9.7-1.3.9-2.8,0-.6,0-.9.7-.3.9-1.8-.1-2.5,0-3.7.8-1.7.9-3.7,0-.6,0-.9c1.3-4.5,5.8-17.6,4.1-21.2s-3.4-3.1-4.7-5.5c-9.7-17.9,4.1-36,23.6-35.2.6,0,1.3,0,1.8,0l2.8.9c14.7,5.9,20.2,23.7,11.1,37s-6.5,4.9-10,8c.1,10.3-1.7,20.5-2,30.8,0,1.5,0,3.1,0,4.6-1.3,5.5-1.4,11.9-1.8,17.6-.7,8.9-1.1,17.9-1.8,26.8-1.5.8-.9,3.1-.9,4.6,0,.6,0,1.2,0,1.8-.4,5.3-2.7,18.3-1.8,22.6s6.1,8.2,7.4,10.6-.1.7,0,.9l.9.9c.1.3-.1.7,0,.9,2.2,5.7,4.9,17.1,5.5,23.1s0,9.5,0,13.9-1,5.8-.9,9.2,0,1.2,0,1.8c-1.2.4-.9,1.8-.9,2.8s0,1.3,0,1.8c-1.5.7-.7,2.6-.9,3.7-.6,2.7-1.8,7.7-2.8,10.2-6,15.3-14.4,18.5-27.7,24.9s-.7-.1-.9,0l-.9.9c-1.8,2.7-1.8,7.6-2.8,10.2-1.2,3-3.9,8.2-5.5,11.1-.3.6-.6,1.3-.9,1.8-6.6,10.6-18.2,20.6-28.7,27.2-2.6,1.7-15.3,7.5-16.1,8.8l-11.5,4.6c-9.3,1.8-18.4,5-27.7,6.9-44.9,9.3-97.9,8.1-142.5-2.6-2.6-.6-16.4-5.3-17.8-5.1l-19.4-8.3Z"
    />
    <path
      fill="currentColor"
      d="M188.9,238.4c17.2-2.1,26.4,19.3,27,33.5.8,17.3-11.8,47-33.2,36-23.2-11.9-20.6-66.1,6.2-69.4Z"
    />
    <path
      fill="currentColor"
      d="M302.5,238.4c22.2-2.2,27.9,27.9,26,44.5-1.8,15.4-16.7,34.2-33.5,24.4-22-12.8-18.4-66.4,7.5-69Z"
    />
  </svg>
);

const TechCookieIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
    <circle
      cx="8.5"
      cy="8.5"
      r="1.5"
      fill="currentColor"
      stroke="none"
      className="text-[#00FFA3]"
    />
    <circle
      cx="15.5"
      cy="12.5"
      r="1.5"
      fill="currentColor"
      stroke="none"
      className="text-[#00FFA3]"
    />
    <circle
      cx="11.5"
      cy="16.5"
      r="1.5"
      fill="currentColor"
      stroke="none"
      className="text-[#00FFA3]"
    />
    <circle
      cx="11"
      cy="11.5"
      r="1"
      fill="currentColor"
      stroke="none"
      className="text-white/30"
    />
    <circle
      cx="7.5"
      cy="14"
      r="1"
      fill="currentColor"
      stroke="none"
      className="text-white/30"
    />
  </svg>
);

const SectionTitle = ({
  title,
  subtitle,
  align = "center",
  noUnderline = false,
  className = "mb-16",
}) => (
  <div
    className={`${className} ${align === "left" ? "text-left" : "text-center"}`}
  >
    <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight">
      {title} <span className="text-mint-400">.</span>
    </h2>
    {subtitle && (
      <p className="text-gray-400 max-w-2xl mx-auto text-lg leading-relaxed">
        {subtitle}
      </p>
    )}
    {!noUnderline && (
      <div
        className={`h-1 w-20 bg-mint-500/50 mt-6 ${
          align === "left" ? "" : "mx-auto"
        } rounded-full shadow-[0_0_15px_rgba(0,255,163,0.5)]`}
      ></div>
    )}
  </div>
);

const FeatureCard = ({ icon: Icon, title, description, variant = "black" }) => {
  const isMint = variant === "mint";

  return (
    <div
      className={`
      group p-8 rounded-none border relative overflow-hidden transition-all duration-300
      ${
        isMint
          ? "bg-[#00FFA3] border-[#00e592] text-black hover:shadow-[0_0_40px_rgba(0,255,163,0.6)]"
          : "bg-[#050505]/80 border-white/5 text-white hover:border-[#00FFA3]/50 hover:shadow-[0_0_30px_rgba(0,255,163,0.1)] backdrop-blur-sm"
      }
    `}
    >
      {/* Decorative Corner for Black Cards */}
      {!isMint && (
        <div className="absolute top-0 right-0 w-0 h-0 border-t-[40px] border-r-[40px] border-t-transparent border-r-white/5 group-hover:border-r-[#00FFA3]/20 transition-colors"></div>
      )}

      <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity pointer-events-none">
        <Icon size={100} className={isMint ? "text-black" : "text-white"} />
      </div>

      <div
        className={`
        w-14 h-14 flex items-center justify-center mb-6 transition-transform duration-300 group-hover:scale-110 rounded-2xl
        ${isMint ? "bg-black/10 text-black" : "bg-[#00FFA3]/10 text-[#00FFA3]"}
      `}
      >
        <Icon size={28} className="animate-float" />
      </div>

      <h3
        className={`text-xl font-bold mb-3 uppercase tracking-wide ${
          isMint ? "text-black" : "text-white"
        }`}
      >
        {title}
      </h3>
      <p
        className={`leading-relaxed text-sm ${
          isMint ? "text-black/80 font-medium" : "text-gray-400"
        }`}
      >
        {description}
      </p>
    </div>
  );
};

const ComparisonRow = ({ problem, solution }) => (
  <div className="relative group rounded-xl p-[1px] overflow-hidden transform transition-transform hover:scale-[1.01]">
    {/* Moving Gradient Border - Fast Spin */}
    <div className="absolute inset-[-200%] bg-[conic-gradient(from_90deg_at_50%_50%,#000000_0%,#00FFA3_50%,#000000_100%)] animate-spin-border opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

    {/* Inner Content */}
    <div className="relative h-full bg-[#020202] rounded-xl p-6 grid grid-cols-1 md:grid-cols-2 gap-6 group-hover:bg-[#00FFA3]/5 transition-colors duration-300 z-10">
      <div className="flex items-start gap-4 relative z-10">
        <div className="mt-1 min-w-[24px] text-red-400">
          <X size={24} />
        </div>
        <div>
          <h4 className="text-gray-300 font-semibold mb-1">Problem</h4>
          <p className="text-gray-500 text-sm">{problem}</p>
        </div>
      </div>
      <div className="flex items-start gap-4 md:border-l md:border-white/10 md:pl-6 relative z-10">
        <div className="mt-1 min-w-[24px] text-[#00FFA3]">
          <ShieldCheck size={24} />
        </div>
        <div>
          <h4 className="text-white font-semibold mb-1">OmniAgents Solution</h4>
          <p className="text-gray-400 text-sm">{solution}</p>
        </div>
      </div>
    </div>
  </div>
);

const AccordionItem = ({ question, answer, isOpen, onClick }) => (
  <div className="border-b border-white/5 last:border-0 z-10 relative">
    <button
      className="w-full py-6 flex items-center justify-between text-left focus:outline-none group"
      onClick={onClick}
    >
      <span
        className={`text-lg font-medium transition-colors ${
          isOpen ? "text-mint-400" : "text-gray-300 group-hover:text-white"
        }`}
      >
        {question}
      </span>
      <span
        className={`transform transition-transform duration-300 ${
          isOpen ? "rotate-180 text-mint-400" : "text-gray-500"
        }`}
      >
        <ChevronDown size={20} />
      </span>
    </button>
    <div
      className={`overflow-hidden transition-all duration-300 ease-in-out ${
        isOpen ? "max-h-96 opacity-100 pb-6" : "max-h-0 opacity-0"
      }`}
    >
      <p className="text-gray-400 leading-relaxed">{answer}</p>
    </div>
  </div>
);

const ChainBadge = ({ name, color, image }) => (
  <div className="flex flex-col items-center justify-center p-4 rounded-xl bg-white/5 border border-white/10 hover:border-mint-500/30 hover:bg-white/10 transition-all cursor-default relative z-10 backdrop-blur-sm">
    <div
      className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-xl mb-2 ${color} relative group`}
    >
      {image ? (
        <>
          {/* Mint Glow behind the image */}
          <div className="absolute inset-0 rounded-full blur-md opacity-60 bg-[#00FFA3] group-hover:opacity-100 transition-opacity duration-300"></div>
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover rounded-full relative z-10"
          />
        </>
      ) : (
        name.charAt(0)
      )}
    </div>
    <span className="text-sm text-gray-400 font-medium">{name}</span>
  </div>
);

// --- Modal Component ---
const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-md transition-opacity animate-fade-in"
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div className="relative w-full max-w-3xl max-h-[85vh] bg-[#050505]/90 backdrop-blur-xl border border-white/10 rounded-2xl shadow-[0_0_50px_rgba(0,255,163,0.1)] flex flex-col overflow-hidden animate-fade-in-up">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/5 bg-gradient-to-r from-white/5 to-transparent">
          <h3 className="text-2xl font-bold text-white flex items-center gap-3">
            <span className="w-2 h-2 rounded-full bg-[#00FFA3] shadow-[0_0_10px_#00FFA3]"></span>
            {title}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-[#00FFA3] transition-colors p-2 rounded-lg hover:bg-[#00FFA3]/10"
          >
            <X size={24} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 md:p-8 overflow-y-auto custom-scrollbar text-gray-300 space-y-6 text-sm leading-relaxed">
          {children}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-white/5 bg-black/50 flex justify-end">
          <button
            onClick={onClose}
            className="bg-white/5 hover:bg-white/10 text-white px-6 py-2 rounded-lg transition-colors font-medium border border-white/10 hover:border-[#00FFA3]/30"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// --- Cookie Banner Component ---
const CookieBanner = ({ isVisible, onAccept, onCustomize }) => {
  if (!isVisible) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-[420px] z-[90] pointer-events-none flex justify-end animate-fade-in-up">
      <div className="bg-[#050505]/95 backdrop-blur-xl border border-[#00FFA3]/20 shadow-[0_10px_40px_rgba(0,255,163,0.15)] rounded-2xl p-6 w-full pointer-events-auto relative overflow-hidden">
        {/* Background Glow */}
        <div className="absolute top-[-50%] right-[-50%] w-full h-full bg-[#00FFA3]/5 rounded-full blur-[50px] pointer-events-none"></div>

        <div className="flex gap-4 mb-5 relative z-10">
          <div className="w-12 h-12 rounded-xl bg-[#00FFA3]/10 flex items-center justify-center flex-shrink-0 border border-[#00FFA3]/20 shadow-[0_0_15px_rgba(0,255,163,0.1)]">
            <TechCookieIcon size={24} className="text-[#00FFA3]" />
          </div>
          <div>
            <h4 className="text-white font-bold text-lg mb-1 tracking-tight">
              Cookie Protocol
            </h4>
            <p className="text-gray-400 text-xs leading-relaxed">
              We use cookies to optimize performance and ensure secure network
              routing. No personal data is tracked or stored.
            </p>
          </div>
        </div>

        <div className="flex gap-3 relative z-10">
          <button
            onClick={onAccept}
            className="flex-1 bg-[#00FFA3] hover:bg-[#00e592] text-black py-2.5 rounded-lg text-sm font-bold transition-all shadow-[0_0_15px_rgba(0,255,163,0.2)] hover:shadow-[0_0_25px_rgba(0,255,163,0.4)]"
          >
            Accept All
          </button>
          <button
            onClick={onCustomize}
            className="flex-1 bg-transparent hover:bg-white/5 text-white py-2.5 rounded-lg text-sm font-medium border border-white/10 hover:border-[#00FFA3]/30 transition-all"
          >
            Preferences
          </button>
        </div>
      </div>
    </div>
  );
};

// --- Main App Component ---

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openFaq, setOpenFaq] = useState(0);
  const [activeLink, setActiveLink] = useState("Home");
  const [activeModal, setActiveModal] = useState(null); // 'privacy', 'terms', 'docs', 'cookies', null
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);

    // Show cookies banner on initial landing with a slight delay for smooth UX
    const timer = setTimeout(() => {
      setShowCookieBanner(true);
    }, 1000);

    // --- SEO & Favicon Injection ---
    document.title = "OmniAgents | Automated Yield AI Workforce";

    // Set Custom Logo as Favicon
    const setFavicon = () => {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href =
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 500'%3E%3Cpath fill='%2300FFA3' d='M66,92.4c-18.6,2.7-8.9,32.7,7.9,22.8s4.7-24.6-7.9-22.8ZM425.4,92.4c-17.8,3.7-8.1,32.7,8.9,22.7,11.6-6.8,4.3-25.5-8.9-22.7ZM201.4,185.2c4,3.5,9.6,6.2,14.9,6.8,15.2,1.5,46.6,1.4,61.9,0,16.5-1.4,16.1-12.2,27.4-16,2.1-.7,5.6-.2,6.8-1.5,1.2-5.4,13.1-42.3,12-44.4-1.7-3.4-27.9-11.1-33-12.3-33-7.7-68.7-6.1-101,4s-18.2,6.1-18.8,8-.2,1.7,0,2.5l11.5,42.2c3.2,1.7,6.9,1.1,10.2,2.7s5.5,5.8,8.1,8ZM72.7,128.2c-2.9-.1-3-.5-2.8,2.3,1.9,25.3,4.2,50.6,6.5,75.8.7,7.4,0,15.3,2.3,22.6,1.8-2.2,8.1-2.8,9.2-4.6s2.2-10.3,2.1-11.6l-17.4-84.5ZM425.6,128.2h-2.8s-17.2,83.7-17.2,83.7c1.4,9.8.8,15.7,12.6,16l7.4-99.8ZM379.1,369.9c19.2-19.5,19.8-47.1,20.7-73.1,1.1-31.1.5-71.3-10.4-100.5s-29.6-48.7-54.3-60.7l-11.1,42.4c20.4,5.2,36.1,18,44.5,37.3,12.1,28.2,12.6,77.6,4,106.9-7.3,24.9-25.5,43.9-50.2,51.9l-3.8,24.8c21.1-3.9,45.4-13.4,60.6-29ZM160.5,136.5c-1.6-1.1-14.3,8-16.5,9.8-30.3,23.5-42.9,55.8-46.3,93.2-2.5,28-4,92.5,9.1,116.5,13.5,24.7,44.2,37,70.4,42.8l-4.5-24.3c-31.7-12.3-48.7-37.3-53.5-70.5-5.6-38.3-3-97.1,34.4-118.8,2.7-1.6,16.8-6.9,17.1-7.8,2-5.7-9.2-33.2-10-41ZM182.4,187.6c-48.7,5.1-55.6,58.5-53.4,98.1,3.3,57.8,29.3,79.6,85.4,85.5,42.5,4.4,116,4.8,140.3-37,17-29.2,17.4-106.6-8.2-131.1-7.4-7.1-26.8-16.6-37-15.8s-4.9,4.3-7.4,6.5c-5.9,5.2-14.4,9.2-22.3,10.1-15.3,1.6-47.3,1.5-62.7,0-5.6-.5-14.6-3.4-19.3-6.6s-8.9-9.6-9.5-9.9c-1.8-.6-4.2,0-6.1.1ZM86.6,238.2c-7.2.8-12.8,7.1-15.9,13.2-8.6,17.3-8.1,60.5,8.6,73.1,6.9,5.2,7.8,5.1,7.3-3.7-.3-6.7-1.7-14.5-1.9-21.2-.7-20.5,0-41.2,1.9-61.5ZM409,327.8c1.1,1.2,6.7-2.8,7.8-3.7,14.7-11.8,15.4-43.1,12.2-60.2-2-10.5-7.4-22.7-18.6-25.7-.2,21,.9,42.2.5,63.3l-1.9,26.3ZM310.1,378.6c-33.6,6.1-68.8,7.7-102.9,3.6-4.4-.5-16.6-3.9-19.5-3.6s-1.4.2-1.9.9c-1,1.4,3.5,18.6,4.9,21s.8,1.5,2.1,1.7c25.7,4,53.1,5.6,79.1,4.2,4.3-.2,30.9-3.2,32.5-4.9s6.6-22.1,5.7-22.9ZM134.2,396.3c-.9,0-4.4-2-6-2.9s-1.8-1.2-2.8-1.8c-13-8.5-22.4-18.1-29.7-31.8s-.4-2.9-2.6-2.4c-.2-.7.1-1.9,0-2.8s-.5-.8-.9-.9c-.1-.6.1-1.4,0-1.8-.8-2.7-2.6-10.2-4.6-11.1s-5.2-.6-7.9-1.8c-4.6-2-8.1-5.8-11.5-9.3s-2.4-2.3-2.8-2.8c-2.4-3.1-4-5.5-5.5-9.2-2.5-6.3-4.7-16.3-5.5-23.1s0-1.9,0-2.8c-.7-8,.1-14.7,0-22.2s0-1.2,0-1.8c1.3-.5.8-1.8.9-2.8s-.1-1.3,0-1.8c1.6-8.6,4.9-16.6,9.2-24,.3-.3.6-.7.9-.9,3.8-3.1,1.3-9.4.9-13.9s0-1.9,0-2.8v-.9c-.2-2.3-.7-4.8-.9-7.4s-.6-7.4-.9-11.1,0-1.9,0-2.8l-.9-2.8c-.1-1.8.1-3.7,0-5.5-.3-3.7-.6-7.4-.9-11.1s0-1.9,0-2.8c0-1.5.6-3.8-.9-4.6-1.2-14.8-1.6-29.8-2.8-44.6-6.2-5.6-11.4-8.8-13.8-17.3l-.9-1.8c0-.3,0-.6,0-.9-1-16.2,11.6-28.9,27.9-26.5,10.5,1.5,16.6,10.5,19.2,20.1-.1.6,0,1.3,0,1.8-.6,3.3-.4,6.4-1.7,9.9s-6.4,8.2-6.7,10c-.6,3.5,1.5,5.5,1.9,7.8s-.1,1.3,0,1.8c3.6,18.8,8.4,37.4,11.1,56.4,2.1.4,1.5-.1,2.1-1.2,1.6-2.9,2.8-7.8,4.4-10.8s3.4-6.4,4.6-8.3c12.7-19.7,28.4-29.8,46.2-43.4,8.8-3.6,16.9-8.7,25.9-12,9-3.4,18.6-5.2,27.7-8.3.6,0,1.2,0,1.8,0l24-3.7c.9,0,1.9,0,2.8,0,5.2.3,10.5-.2,15.7,0s4.9-.1,7.4,0c27.2,1.3,56.6,8.9,80.4,22.2s5.8,2.7,7.4,3.7c7.8,4.9,20.1,15.4,26.8,22.2.3.3.6.6.9.9l1.8,1.8c1.3,1.4,3.2,3.9,4.6,5.5s2.6,4.2,4.6,5.5c.2,1.3.8,1.5.9,1.8s.8.6.9.9c.3.6.6,1.2.9,1.8,3.6,6.9,7.8,13.5,11.6,20.3,1.5-2.8.9-6.3,1.4-9.2s.6-4,.9-5.5.6-.4.9-1.8-.1-1.3,0-1.8c.8-4,1.9-7.7,2.8-12s0-.6,0-.9.7-1.3.9-2.8,0-.6,0-.9.7-.3.9-1.8-.1-2.5,0-3.7.8-1.7.9-3.7,0-.6,0-.9c1.3-4.5,5.8-17.6,4.1-21.2s-3.4-3.1-4.7-5.5c-9.7-17.9,4.1-36,23.6-35.2.6,0,1.3,0,1.8,0l2.8.9c14.7,5.9,20.2,23.7,11.1,37s-6.5,4.9-10,8c.1,10.3-1.7,20.5-2,30.8,0,1.5,0,3.1,0,4.6-1.3,5.5-1.4,11.9-1.8,17.6-.7,8.9-1.1,17.9-1.8,26.8-1.5.8-.9,3.1-.9,4.6,0,.6,0,1.2,0,1.8-.4,5.3-2.7,18.3-1.8,22.6s6.1,8.2,7.4,10.6-.1.7,0,.9l.9.9c.1.3-.1.7,0,.9,2.2,5.7,4.9,17.1,5.5,23.1s0,9.5,0,13.9-1,5.8-.9,9.2,0,1.2,0,1.8c-1.2.4-.9,1.8-.9,2.8s0,1.3,0,1.8c-1.5.7-.7,2.6-.9,3.7-.6,2.7-1.8,7.7-2.8,10.2-6,15.3-14.4,18.5-27.7,24.9s-.7-.1-.9,0l-.9.9c-1.8,2.7-1.8,7.6-2.8,10.2-1.2,3-3.9,8.2-5.5,11.1-.3.6-.6,1.3-.9,1.8-6.6,10.6-18.2,20.6-28.7,27.2-2.6,1.7-15.3,7.5-16.1,8.8l-11.5,4.6c-9.3,1.8-18.4,5-27.7,6.9-44.9,9.3-97.9,8.1-142.5-2.6-2.6-.6-16.4-5.3-17.8-5.1l-19.4-8.3Z'/%3E%3Cpath fill='%2300FFA3' d='M188.9,238.4c17.2-2.1,26.4,19.3,27,33.5.8,17.3-11.8,47-33.2,36-23.2-11.9-20.6-66.1,6.2-69.4Z'/%3E%3Cpath fill='%2300FFA3' d='M302.5,238.4c22.2-2.2,27.9,27.9,26,44.5-1.8,15.4-16.7,34.2-33.5,24.4-22-12.8-18.4-66.4,7.5-69Z'/%3E%3C/svg%3E";
    };

    // Inject Meta Tags for SEO and Social Sharing
    const setMetaTag = (name, content, attribute = "name") => {
      let meta = document.querySelector(`meta[${attribute}='${name}']`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attribute, name);
        document.getElementsByTagName("head")[0].appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setFavicon();
    setMetaTag(
      "description",
      "A network of autonomous AI agents that execute revenue-generating tasks across major chains. Activate your cluster and receive yield directly into your wallet."
    );
    setMetaTag(
      "keywords",
      "Web3, AI Agents, Automated Yield, Crypto Arbitrage, OmniAgents"
    );

    // Open Graph / Facebook
    setMetaTag(
      "og:title",
      "OmniAgents | Automated Yield AI Workforce",
      "property"
    );
    setMetaTag(
      "og:description",
      "Deploy autonomous AI agents to execute revenue-generating tasks across major chains.",
      "property"
    );
    setMetaTag("og:image", "https://i.imgur.com/C9qUYTk.jpeg", "property");
    setMetaTag("og:type", "website", "property");

    // Twitter / X
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", "OmniAgents | Automated Yield AI Workforce");
    setMetaTag(
      "twitter:description",
      "Deploy autonomous AI agents to execute revenue-generating tasks across major chains."
    );
    setMetaTag("twitter:image", "https://i.imgur.com/C9qUYTk.jpeg");

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timer);
    };
  }, []);

  const navLinks = [
    { name: "Home", href: "#" },
    { name: "Features", href: "#features" },
    { name: "Solutions", href: "#solutions" },
    { name: "$OMAG", href: "#token" },
    { name: "Roadmap", href: "#roadmap" },
    { name: "FAQ", href: "#faq" },
  ];

  return (
    <div className="min-h-screen bg-[#030303] text-white selection:bg-mint-500/30 selection:text-mint-200 font-sans overflow-x-hidden">
      {/* Background - Global Grid & Ambience */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        {/* Static Squared Grid - Increased opacity to 0.08 so it shows through transparent sections */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:40px_40px] opacity-[0.08]"></div>

        {/* Ambient Glows */}
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-mint-500/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-[10%] right-[-5%] w-[30%] h-[30%] bg-purple-900/10 rounded-full blur-[100px]" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 brightness-100 contrast-150 mix-blend-overlay"></div>
      </div>

      {/* Navbar */}
      <nav
        className={`fixed w-full z-50 transition-all duration-300 ${
          scrolled
            ? "bg-[#030303]/90 backdrop-blur-md border-b border-[#00FFA3]/20 py-4"
            : "bg-transparent py-6 border-b border-[#00FFA3]/5"
        }`}
      >
        <div className="container mx-auto px-6 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Logo />
            <span className="text-xl font-bold tracking-wide">
              Omni<span className="text-mint-400">Agents</span>
            </span>
          </div>

          <div className="hidden md:flex items-center gap-4">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setActiveLink(link.name)}
                className={`text-sm font-medium transition-colors uppercase tracking-wider relative py-1 ${
                  activeLink === link.name
                    ? "text-white"
                    : "text-gray-300 hover:text-[#00FFA3]"
                }`}
              >
                {link.name}
                {activeLink === link.name && (
                  <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-[#00FFA3] to-[#00aa6c]"></div>
                )}
              </a>
            ))}
            <div className="h-6 w-px bg-white/20 mx-4"></div>

            {/* Telegram 1 */}
            <a
              href="https://t.me/OmniAgents"
              target="_blank"
              rel="noreferrer"
              className="text-[#00FFA3] hover:text-white transition-colors"
            >
              <Send size={18} />
            </a>

            {/* Telegram 2 */}
            <a
              href="https://t.me/OmniAgentsAI"
              target="_blank"
              rel="noreferrer"
              className="text-[#00FFA3] hover:text-white transition-colors"
            >
              <Send size={18} />
            </a>

            {/* X (Twitter) */}
            <a
              href="https://x.com/omni_agentsai"
              target="_blank"
              rel="noreferrer"
              className="text-[#00FFA3] hover:text-white transition-colors"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 1200 1227"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
              </svg>
            </a>

            <button className="bg-[#00FFA3] hover:bg-[#00e592] text-black px-6 py-2 rounded-sm text-sm font-bold transition-all hover:shadow-[0_0_20px_rgba(0,255,163,0.4)] uppercase tracking-wide skew-x-[-10deg] ml-4 flex items-center gap-2">
              <span className="relative flex h-2 w-2 skew-x-[10deg]">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-black opacity-30"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-black"></span>
              </span>
              <span className="skew-x-[10deg] inline-block">Launch App</span>
            </button>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white"
            >
              {isMenuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-[#050505] border-b border-white/10 p-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`text-lg font-medium ${
                  activeLink === link.name ? "text-[#00FFA3]" : "text-gray-300"
                }`}
                onClick={() => {
                  setActiveLink(link.name);
                  setIsMenuOpen(false);
                }}
              >
                {link.name}
              </a>
            ))}
            <button className="bg-mint-500 text-black px-6 py-3 rounded-lg font-bold w-full mt-4">
              Launch App
            </button>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative w-full pt-24 pb-8 md:pt-32 md:pb-12 z-10 overflow-hidden">
        {/* Specific Animated Hero Futuristic Grid - FULL WIDTH */}
        <div className="absolute inset-0 pointer-events-none z-0">
          {/* Solid BG to block global static grid in Hero */}
          <div className="absolute inset-0 bg-[#030303]"></div>

          {/* Diagonal Moving Grid */}
          <div className="absolute -inset-[50px] opacity-20">
            <div className="w-full h-full bg-[linear-gradient(to_right,#00ffa3_1px,transparent_1px),linear-gradient(to_bottom,#00ffa3_1px,transparent_1px)] bg-[size:50px_50px] animate-grid-diagonal"></div>
          </div>

          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_30%,#030303_100%)] z-10"></div>

          {/* Bottom Gradient for seamless transition to next section */}
          <div className="absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-[#030303]/90 to-transparent z-10"></div>
        </div>

        {/* Content Container */}
        <div className="container mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-0 items-center">
            {/* Text Content - Removed order classes to restore default flow (Text first on mobile) */}
            <div className="space-y-8 animate-fade-in-up max-w-2xl">
              <h1 className="text-5xl md:text-7xl font-bold leading-[1.1] tracking-tight">
                Your AI workforce for <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00FFA3] to-[#00aa6c]">
                  Automated Yield
                </span>
              </h1>

              <p className="text-gray-400 text-lg md:text-xl max-w-lg leading-relaxed">
                A network of autonomous AI agents that execute
                revenue-generating tasks across major chains. Activate your
                cluster and receive yield directly into your wallet.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                {/* Launch App Button - Skewed & Rounded Style */}
                <button className="group relative px-8 py-4 bg-[#00FFA3] text-black font-bold rounded-lg transform -skew-x-12 overflow-hidden transition-all hover:shadow-[0_0_40px_rgba(0,255,163,0.4)] flex items-center justify-center">
                  <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-shimmer skew-x-12" />
                  <span className="flex items-center gap-2 relative z-10 transform skew-x-12 uppercase tracking-wide">
                    Launch App <ArrowRight size={18} />
                  </span>
                </button>

                {/* Community Button - Skewed & Rounded Style (Outline) */}
                <a
                  href="https://t.me/OmniAgents"
                  target="_blank"
                  rel="noreferrer"
                  className="relative px-8 py-4 bg-transparent text-white font-semibold border border-white/20 hover:border-[#00FFA3]/50 hover:bg-[#00FFA3]/5 rounded-lg transform -skew-x-12 transition-all flex items-center justify-center group gap-2"
                >
                  <span className="relative z-10 transform skew-x-12 flex items-center gap-2 uppercase tracking-wide">
                    <Send size={18} /> Community
                  </span>
                </a>
              </div>

              <div className="flex items-center gap-6 pt-6 text-sm text-gray-500 font-mono">
                <span>// Powered by Web3 & AI</span>
                <span>// Cross-chain Ready</span>
              </div>
            </div>

            {/* 3D Video Animation - Removed order classes, now naturally appears below text on mobile */}
            <div className="relative w-full flex items-center justify-center lg:justify-start lg:ml-12">
              <div className="relative w-[200px] sm:w-[300px] md:w-[360px] aspect-[3/4] flex items-center justify-center">
                {/* Rotating Mint Glow Background */}
                <div className="absolute inset-0 z-0 flex items-center justify-center">
                  <div className="w-[120%] h-[120%] bg-gradient-to-br from-[#00FFA3]/40 via-transparent to-[#00FFA3]/40 rounded-full blur-3xl animate-spin-slow"></div>
                </div>

                {/* Video Box */}
                <div className="relative w-full h-full bg-black rounded-2xl border border-white/10 overflow-hidden group shadow-[0_0_30px_rgba(0,255,163,0.2)] z-10">
                  {/* Overlay Gradient for integration */}
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#030303] z-30 pointer-events-none"></div>

                  {/* Edge Grid Overlay */}
                  <div
                    className="absolute inset-0 z-20 pointer-events-none opacity-30"
                    style={{
                      backgroundImage:
                        "linear-gradient(to right, #00FFA3 1px, transparent 1px), linear-gradient(to bottom, #00FFA3 1px, transparent 1px)",
                      backgroundSize: "40px 40px",
                      maskImage:
                        "radial-gradient(circle at center, transparent 40%, black 100%)",
                      WebkitMaskImage:
                        "radial-gradient(circle at center, transparent 40%, black 100%)",
                    }}
                  ></div>

                  <video
                    src="https://i.imgur.com/xfZ41do.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="absolute inset-0 w-full h-full object-cover z-10"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section - Semi-Transparent Gradient for Grid Visibility */}
      <section className="pt-12 pb-12 bg-gradient-to-b from-[#030303]/90 to-[#020202]/90 relative overflow-hidden">
        {/* Subtle Ambient Glow */}
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] bg-mint-500/5 rounded-full blur-[120px] pointer-events-none"></div>

        <div className="container mx-auto px-6 relative z-10">
          <SectionTitle
            title="What is OmniAgents?"
            subtitle="The automated income layer for Web3."
            className="mb-8"
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-4">
            {[
              {
                num: "01",
                title: "Activate",
                desc: "Users simply activate a cluster. No complex configuration needed.",
                color: "text-mint-400",
                image: "https://i.imgur.com/C9qUYTk.jpeg",
              },
              {
                num: "02",
                title: "Execute",
                desc: "Agents operate via transparent onchain execution based on secure rules.",
                color: "text-white",
                image: "https://i.imgur.com/05Hgnj7.jpeg",
              },
              {
                num: "03",
                title: "Yield",
                desc: "Funds stay in your wallet. Yield is streamed directly to you.",
                color: "text-mint-400",
                image: "https://i.imgur.com/MZ0l7We.jpeg",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="flex flex-col gap-6 group max-w-[300px] mx-auto w-full"
              >
                {/* Card Container with Animated Gradient Border */}
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden shadow-2xl">
                  {/* Animated Gradient Border Layer - Increased Opacity */}
                  <div className="absolute inset-0 bg-gradient-to-br from-[#00FFA3]/60 via-transparent to-[#00FFA3]/60 bg-[length:200%_200%] animate-gradient-xy opacity-80 group-hover:opacity-100 transition-opacity duration-500"></div>

                  {/* Inner Content Layer */}
                  <div className="absolute inset-[1px] bg-[#050505] rounded-lg overflow-hidden">
                    {item.image ? (
                      <>
                        {/* Wrapper handles the Hover Zoom */}
                        <div className="absolute inset-0 w-full h-full transition-transform duration-700 group-hover:scale-110 flex items-center justify-center">
                          {/* Image handles the Idle Breathing - Reduced size to 70% (30% reduction) */}
                          <img
                            src={item.image}
                            alt={item.title}
                            className="w-[70%] h-[70%] object-cover animate-breathe rounded-md shadow-lg"
                          />
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent pointer-events-none"></div>
                      </>
                    ) : (
                      <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                        <div className="text-center">
                          <span className="block text-4xl font-bold text-white/5 group-hover:text-mint-500/20 transition-colors mb-2">
                            {item.num}
                          </span>
                          <span className="text-xs text-gray-600 font-mono tracking-widest border border-white/10 px-2 py-1">
                            IMAGE 3:4
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Animated Corner Triangle */}
                    <div className="absolute bottom-0 right-0 w-10 h-10 bg-gradient-to-tl from-[#00FFA3] to-transparent clip-corner-br opacity-60 group-hover:opacity-100 animate-pulse-slow z-10 transition-opacity"></div>
                  </div>
                </div>

                <div className="px-2">
                  <div className="flex items-baseline gap-3 mb-2">
                    <span
                      className={`text-sm font-mono opacity-50 ${item.color}`}
                    >
                      {item.num}.
                    </span>
                    <h3
                      className={`text-2xl font-bold uppercase ${item.color}`}
                    >
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-gray-400 leading-relaxed text-sm pl-8 border-l border-white/10">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Features - Semi-Transparent Gradient */}
      <section
        id="features"
        className="pt-12 pb-12 container mx-auto px-6 relative overflow-hidden bg-gradient-to-b from-[#020202]/90 to-[#030303]/90"
      >
        {/* Subtle right-side glow */}
        <div className="absolute top-1/2 right-[-10%] w-[500px] h-[500px] bg-purple-900/5 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="relative z-10">
          <SectionTitle
            title="Key Features"
            subtitle="Advanced AI infrastructure built for autonomous yield generation."
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
            {[
              {
                icon: Bot,
                title: "Autonomous Yield Agents",
                desc: "Each agent works independently, performing tasks such as trading, arbitrage, liquidity actions, data tasks and microjobs.",
              },
              {
                icon: Globe,
                title: "Cross-Chain Intelligence",
                desc: "Agents function across Ethereum, BNB Chain, Polygon, Arbitrum, Base, Solana and TON, accessing opportunities everywhere.",
              },
              {
                icon: Zap,
                title: "Smart Task Engine",
                desc: "Constantly scans for revenue paths including volatility moves, safe arbitrage, stablecoin loops and simple automated jobs.",
              },
              {
                icon: TrendingUp,
                title: "Optimized Execution",
                desc: "Agents refine behavior continuously using shared performance data while staying within controlled risk boundaries.",
              },
              {
                icon: Code,
                title: "Yield Streamed to Wallet",
                desc: "All activity takes place onchain with visible transaction flow. Profits are delivered without intermediaries.",
              },
              {
                icon: Activity,
                title: "Performance Ranking",
                desc: "Real-time ranking display showing the most successful agents and clusters in the network.",
              },
            ].map((feature, idx) => {
              const variant = idx % 2 === 0 ? "mint" : "black";
              return (
                <FeatureCard
                  key={idx}
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.desc}
                  variant={variant}
                />
              );
            })}
          </div>
        </div>
      </section>

      {/* Problems vs Solutions - Semi-Transparent Gradient */}
      <section
        id="solutions"
        className="pt-12 pb-12 bg-gradient-to-b from-[#030303]/90 to-[#050505]/90 relative overflow-hidden"
      >
        <div className="container mx-auto px-6 relative z-10">
          <SectionTitle
            title="Solving the Complexity"
            subtitle="Bridging the gap between manual effort and automated AI profitability."
          />

          <div className="space-y-6 max-w-4xl mx-auto">
            <ComparisonRow
              problem="Most users lack the skill or time to trade or manage automation."
              solution="Passive income without complexity. OmniAgents handles every step through AI."
            />
            <ComparisonRow
              problem="Markets move fast and every ecosystem behaves differently."
              solution="Fragmented opportunities unified. OmniAgents works across all major networks."
            />
            <ComparisonRow
              problem="Servers, coding, configuration and maintenance create barriers."
              solution="One-click activation. No expensive servers or confusing bot setups."
            />
            <ComparisonRow
              problem="Human strategies age and fail over time."
              solution="Continuous adaptation. Agents learn from global network performance."
            />
            <ComparisonRow
              problem="Many yield protocols hide their internal logic."
              solution="Full transparency. Everything executes onchain with clear yield flows."
            />
          </div>
        </div>
      </section>

      {/* Token Utility - Semi-Transparent Gradient */}
      <section
        id="token"
        className="pt-12 pb-24 container mx-auto px-6 relative overflow-hidden bg-gradient-to-b from-[#050505]/90 to-[#030303]/90"
      >
        {/* Soft Radial Glow */}
        <div className="absolute inset-0 z-0 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,transparent_0%,#00ffa303_40%,transparent_70%)] rounded-full animate-pulse-slow"></div>
        </div>

        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-mint-500/5 rounded-full blur-[100px] pointer-events-none"></div>

        {/* Section Title moved outside flex container to align coin with list items */}
        <div className="relative z-10 mb-16 lg:w-1/2">
          <SectionTitle
            align="left"
            title="Token Utility: $OMAG"
            subtitle="$OMAG powers the OmniAgents network, serving as the access and reward layer of the ecosystem."
            className="mb-0"
          />
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-16 relative z-10">
          <div className="lg:w-1/2">
            <div className="space-y-8">
              {[
                {
                  title: "Agent Activation Tiers",
                  desc: "Access stronger, faster or more specialized agents by holding $OMAG.",
                  icon: Layers,
                  color: "text-white",
                },
                {
                  title: "Reward Distribution",
                  desc: "A portion of yield and performance bonuses is delivered in $OMAG.",
                  icon: TrendingUp,
                  color: "text-[#00FFA3]",
                },
                {
                  title: "Agent Upgrades",
                  desc: "Spend $OMAG to unlock improved risk controls and high-frequency execution.",
                  icon: Cpu,
                  color: "text-white",
                },
                {
                  title: "Network Priority",
                  desc: "Holders receive faster routing, wider chain coverage and cluster capacity.",
                  icon: Zap,
                  color: "text-[#00FFA3]",
                },
              ].map((item, idx) => (
                <div key={idx} className="flex gap-5 group">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-xl bg-[#00FFA3]/5 border border-[#00FFA3]/20 flex items-center justify-center group-hover:bg-[#00FFA3]/10 group-hover:border-[#00FFA3]/50 transition-all duration-300 shadow-[0_0_15px_rgba(0,255,163,0.05)] group-hover:shadow-[0_0_20px_rgba(0,255,163,0.2)]">
                      <item.icon
                        size={24}
                        className="text-[#00FFA3] animate-float"
                      />
                    </div>
                  </div>
                  <div>
                    <h4
                      className={`font-bold text-lg mb-2 ${item.color} group-hover:text-[#00FFA3] transition-colors`}
                    >
                      {item.title}
                    </h4>
                    <p className="text-gray-400 leading-relaxed text-sm">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2 flex justify-center relative">
            {/* Grid Background behind circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] z-0 pointer-events-none">
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #00FFA3 1px, transparent 1px), linear-gradient(to bottom, #00FFA3 1px, transparent 1px)",
                  backgroundSize: "40px 40px",
                  opacity: 0.15,
                  maskImage:
                    "radial-gradient(circle at center, black 20%, transparent 70%)",
                  WebkitMaskImage:
                    "radial-gradient(circle at center, black 20%, transparent 70%)",
                }}
              ></div>
            </div>

            {/* 3D Coin Video - Removed cursor-pointer */}
            <div className="w-80 h-80 relative group z-10">
              <div className="absolute inset-0 bg-gradient-to-tr from-[#00FFA3]/20 to-purple-500/20 rounded-full animate-pulse blur-xl"></div>
              <div className="relative w-full h-full bg-black/80 backdrop-blur-xl border border-white/10 rounded-full flex items-center justify-center shadow-[0_0_50px_rgba(0,255,163,0.15)] transition-all group-hover:scale-105 overflow-hidden">
                <video
                  src="https://i.imgur.com/iy9Ql2a.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-full object-cover scale-110"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Supported Chains - Semi-Transparent Gradient */}
      <section className="py-16 border-t border-white/5 bg-gradient-to-b from-[#030303]/90 to-[#010101]/90 relative">
        <div className="container mx-auto px-6 text-center relative z-10">
          <p className="text-gray-500 mb-8 font-mono text-sm uppercase tracking-widest">
            Operating Across Major Ecosystems
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8">
            <ChainBadge
              name="Ethereum"
              color="bg-indigo-500"
              image="https://i.imgur.com/OMOuH0l.jpeg"
            />
            <ChainBadge
              name="BNB Chain"
              color="bg-yellow-500"
              image="https://i.imgur.com/GBPjMxW.jpeg"
            />
            <ChainBadge
              name="Polygon"
              color="bg-purple-500"
              image="https://i.imgur.com/m6pAfsc.jpeg"
            />
            <ChainBadge
              name="Arbitrum"
              color="bg-blue-400"
              image="https://i.imgur.com/ciZQE7y.jpeg"
            />
            <ChainBadge
              name="Base"
              color="bg-blue-600"
              image="https://i.imgur.com/Udna3sE.jpeg"
            />
            <ChainBadge
              name="Solana"
              color="bg-green-400"
              image="https://i.imgur.com/TtKlDil.jpeg"
            />
            <ChainBadge
              name="TON"
              color="bg-blue-300"
              image="https://i.imgur.com/nLUKWKK.jpeg"
            />
          </div>
        </div>
      </section>

      {/* Roadmap - Semi-Transparent Gradient */}
      <section
        id="roadmap"
        className="pt-24 pb-12 container mx-auto px-6 relative overflow-hidden bg-gradient-to-b from-[#010101]/90 to-[#030303]/90"
      >
        {/* Subtle Ambient Glow */}
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-blue-900/5 rounded-full blur-[120px] pointer-events-none"></div>

        <div className="relative z-10">
          <SectionTitle title="Development Roadmap" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
            <div className="hidden lg:block absolute top-8 left-0 w-full h-0.5 bg-gradient-to-r from-mint-500/20 via-mint-500 to-mint-500/20 z-0"></div>

            {[
              {
                phase: "Phase 1",
                title: "Foundation",
                icon: Layers,
                items: [
                  "Core agent engine",
                  "Cluster dashboard",
                  "Basic revenue tasks",
                  "Onchain yield routing",
                ],
              },
              {
                phase: "Phase 2",
                title: "Expansion",
                icon: Globe,
                items: [
                  "Multi-chain execution",
                  "Expanded task types",
                  "Cross-chain data merging",
                ],
              },
              {
                phase: "Phase 3",
                title: "Evolution",
                icon: Cpu,
                items: [
                  "Advanced agent modules",
                  "Custom risk settings",
                  "High-frequency mission engine",
                ],
              },
              {
                phase: "Phase 4",
                title: "Ecosystem",
                icon: Rocket,
                items: [
                  "External task marketplace",
                  "Partnership integrations",
                  "Institution-level fleets",
                ],
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="relative z-10 bg-[#050505] border border-white/5 p-6 rounded-xl hover:border-mint-500/40 transition-colors group"
              >
                {/* Header with Glowing Dot */}
                <div className="flex items-center gap-3 mb-4">
                  <span className="relative flex h-3 w-3">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00FFA3] opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-[#00FFA3] shadow-[0_0_10px_#00FFA3]"></span>
                  </span>
                  <span className="text-mint-400 font-mono text-sm tracking-wider uppercase">
                    {item.phase}
                  </span>
                </div>

                {/* Icon & Title */}
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-lg bg-[#00FFA3]/10 flex items-center justify-center border border-[#00FFA3]/20 group-hover:border-[#00FFA3]/50 transition-colors">
                    <item.icon size={20} className="text-[#00FFA3]" />
                  </div>
                  <h3 className="text-xl font-bold text-white">{item.title}</h3>
                </div>

                <ul className="space-y-3">
                  {item.items.map((sub, i) => (
                    <li
                      key={i}
                      className="text-gray-400 text-sm flex items-start gap-2"
                    >
                      <div className="w-1 h-1 bg-gray-500 rounded-full mt-1.5 flex-shrink-0"></div>
                      <span className="leading-snug">{sub}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section
        id="faq"
        className="pt-12 pb-24 bg-gradient-to-b from-[#030303]/90 to-[#000000]/90 relative z-10"
      >
        <div className="container mx-auto px-6 max-w-3xl">
          <SectionTitle title="Frequently Asked Questions" />
          <div className="space-y-2">
            {[
              {
                q: "What does OmniAgents do?",
                a: "It provides AI agents that execute revenue tasks onchain and send the yield directly to your wallet.",
              },
              {
                q: "Is it safe to use?",
                a: "Yes. Agents operate under strict protective rules and all actions are executed onchain. You keep full control of your funds at all times.",
              },
              {
                q: "Do I need experience to use it?",
                a: "No. Agents are pre-configured and adjust automatically. Just activate a cluster and monitor results.",
              },
              {
                q: "Which chains are supported?",
                a: "Currently Ethereum, BNB Chain, Polygon, Arbitrum, Base, Solana and TON.",
              },
              {
                q: "How do I earn yield?",
                a: "Your agent cluster performs tasks (arbitrage, trading, etc.) and sends the earned value directly to your wallet.",
              },
              {
                q: "What is $OMAG used for?",
                a: "$OMAG unlocks agent tiers, upgrades, network priority, and is used for reward distribution.",
              },
            ].map((faq, idx) => (
              <AccordionItem
                key={idx}
                question={faq.q}
                answer={faq.a}
                isOpen={openFaq === idx}
                onClick={() => setOpenFaq(idx === openFaq ? -1 : idx)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Community / CTA */}
      <section className="py-24 container mx-auto px-6 text-center relative z-10 bg-black/90">
        <div className="max-w-4xl mx-auto bg-gradient-to-b from-white/5 to-transparent border border-white/10 rounded-3xl p-12 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-mint-500 to-transparent"></div>

          <h2 className="text-4xl font-bold text-white mb-6">
            Join the Revolution
          </h2>
          <p className="text-gray-400 mb-8 max-w-xl mx-auto">
            Become part of the OmniAgents community. Stay updated on the latest
            agent capabilities and yield strategies.
          </p>

          <div className="flex flex-wrap justify-center gap-5">
            <a
              href="https://t.me/OmniAgents"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-3 bg-[#00FFA3] hover:bg-[#00e592] text-black px-8 py-4 rounded-xl transition-all font-bold shadow-[0_0_20px_rgba(0,255,163,0.1)] hover:shadow-[0_0_30px_rgba(0,255,163,0.3)]"
            >
              <Send size={22} /> Telegram Chat
            </a>
            <a
              href="https://t.me/OmniAgentsAI"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-3 bg-[#08100c] border border-[#00FFA3] hover:bg-[#00FFA3]/10 text-white px-8 py-4 rounded-xl transition-all font-bold shadow-[0_0_15px_rgba(0,255,163,0.05)] hover:shadow-[0_0_20px_rgba(0,255,163,0.2)]"
            >
              <Send size={22} /> Announcements
            </a>
            <a
              href="https://x.com/omni_agentsai"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-3 bg-[#020202] border border-[#00FFA3] hover:bg-[#00FFA3]/10 text-white px-8 py-4 rounded-xl transition-all font-bold shadow-[0_0_15px_rgba(0,255,163,0.05)] hover:shadow-[0_0_20px_rgba(0,255,163,0.2)]"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 1200 1227"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
              </svg>{" "}
              Follow on X
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#020202] pt-20 pb-8 border-t border-white/5 relative z-10 overflow-hidden">
        {/* Decorative Top Glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60%] h-[1px] bg-gradient-to-r from-transparent via-[#00FFA3]/50 to-transparent"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#00FFA3]/5 rounded-full blur-[150px] pointer-events-none"></div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8 mb-16">
            {/* Brand & Description */}
            <div className="md:col-span-12 lg:col-span-5">
              <div className="flex items-center gap-2 mb-6">
                <Logo />
                <span className="text-2xl font-bold tracking-wide text-white">
                  Omni<span className="text-mint-400">Agents</span>
                </span>
              </div>
              <p className="text-gray-400 leading-relaxed max-w-sm mb-8">
                The automated income layer for Web3. Deploy autonomous AI agents
                to execute revenue-generating tasks across major chains and
                receive yield directly to your wallet.
              </p>

              {/* Launch App Button - Footer Version */}
              <button className="group relative px-6 py-3 bg-[#00FFA3]/10 text-[#00FFA3] font-bold rounded-lg border border-[#00FFA3]/30 hover:bg-[#00FFA3] hover:text-black transition-all duration-300 flex items-center gap-2">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-current opacity-60"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-current"></span>
                </span>
                <span className="uppercase tracking-wide text-sm">
                  Launch App
                </span>
              </button>
            </div>

            {/* Navigation Links */}
            <div className="md:col-span-6 lg:col-span-4">
              <h4 className="text-white font-bold mb-6 uppercase tracking-widest text-sm">
                Navigation
              </h4>
              <ul className="grid grid-cols-2 gap-y-4 gap-x-4">
                {navLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      onClick={() => setActiveLink(link.name)}
                      className={`text-sm font-medium transition-colors hover:text-[#00FFA3] flex items-center gap-2 ${
                        activeLink === link.name
                          ? "text-[#00FFA3]"
                          : "text-gray-400"
                      }`}
                    >
                      <span className="w-1 h-1 rounded-full bg-current opacity-50"></span>
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Socials & Connect */}
            <div className="md:col-span-6 lg:col-span-3">
              <h4 className="text-white font-bold mb-6 uppercase tracking-widest text-sm">
                Connect
              </h4>
              <div className="flex flex-col gap-4">
                <a
                  href="https://t.me/OmniAgents"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-[#00FFA3] transition-colors w-fit"
                >
                  <div className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center">
                    <Send size={18} />
                  </div>
                  <span className="text-sm font-medium">Telegram Chat</span>
                </a>
                <a
                  href="https://t.me/OmniAgentsAI"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-[#00FFA3] transition-colors w-fit"
                >
                  <div className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center">
                    <Send size={18} />
                  </div>
                  <span className="text-sm font-medium">Announcements</span>
                </a>
                <a
                  href="https://x.com/omni_agentsai"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-[#00FFA3] transition-colors w-fit"
                >
                  <div className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 1200 1227"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
                    </svg>
                  </div>
                  <span className="text-sm font-medium">Follow on X</span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6 md:gap-4">
            <div className="text-gray-500 text-sm flex items-center gap-2">
              <span className="text-[#00FFA3]">&copy;</span>{" "}
              {new Date().getFullYear()} OmniAgents AI. All rights reserved.
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 font-medium">
              <button
                onClick={() => setActiveModal("privacy")}
                className="hover:text-[#00FFA3] transition-colors"
              >
                Privacy Policy
              </button>
              <button
                onClick={() => setActiveModal("terms")}
                className="hover:text-[#00FFA3] transition-colors"
              >
                Terms of Service
              </button>
              <button
                onClick={() => setActiveModal("cookies")}
                className="hover:text-[#00FFA3] transition-colors"
              >
                Cookie Settings
              </button>
              <button
                onClick={() => setActiveModal("docs")}
                className="hover:text-[#00FFA3] transition-colors text-[#00FFA3]/70"
              >
                Documentation
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals & Popups */}
      <CookieBanner
        isVisible={showCookieBanner}
        onAccept={() => setShowCookieBanner(false)}
        onCustomize={() => {
          setShowCookieBanner(false);
          setActiveModal("cookies");
        }}
      />

      <Modal
        isOpen={activeModal === "privacy"}
        onClose={() => setActiveModal(null)}
        title="Privacy Policy"
      >
        <div className="space-y-6">
          <p>Last updated: {new Date().toLocaleDateString()}</p>
          <p>
            At OmniAgents AI, we respect your privacy and are committed to
            protecting your personal data. This Privacy Policy explains how we
            collect, use, and safeguard your information when you interact with
            our decentralized application and smart contracts.
          </p>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            1. Information We Collect
          </h4>
          <ul className="list-disc pl-5 space-y-2 text-gray-400">
            <li>
              <strong className="text-gray-200">Onchain Data:</strong> Wallet
              addresses, transaction history, and smart contract interactions
              (publicly available on blockchains).
            </li>
            <li>
              <strong className="text-gray-200">Usage Data:</strong> Anonymous
              analytics data including browser type, network preferences, and
              application interactions to improve system performance.
            </li>
            <li>
              We <strong className="text-[#00FFA3]">do not</strong> collect
              sensitive personal information (PII) such as names, addresses, or
              traditional financial details.
            </li>
          </ul>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            2. How We Use Your Information
          </h4>
          <p>We use the collected information primarily to:</p>
          <ul className="list-disc pl-5 space-y-2 text-gray-400">
            <li>
              Facilitate yield routing and optimize agent cluster execution
              paths.
            </li>
            <li>
              Monitor network health, security, and prevent fraudulent
              activities.
            </li>
            <li>
              Improve our user interface and operational algorithms over time.
            </li>
          </ul>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            3. Third-Party Protocols
          </h4>
          <p>
            OmniAgents interacts with third-party decentralized finance (DeFi)
            protocols. We are not responsible for the privacy practices or data
            collection policies of these external networks or contracts. Please
            review their respective policies.
          </p>
        </div>
      </Modal>

      <Modal
        isOpen={activeModal === "terms"}
        onClose={() => setActiveModal(null)}
        title="Terms of Service"
      >
        <div className="space-y-6">
          <p>Last updated: {new Date().toLocaleDateString()}</p>
          <p>
            By accessing or using the OmniAgents protocol, you agree to be bound
            by these Terms of Service. If you disagree with any part of the
            terms, you may not access the service.
          </p>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            1. Nature of the Service
          </h4>
          <p>
            OmniAgents is a decentralized suite of smart contracts and AI agents
            designed to automate yield-generating tasks across supported
            blockchains. We do not take custody of your funds; you maintain
            absolute control over your digital assets at all times through your
            non-custodial wallet.
          </p>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            2. Assumption of Risk
          </h4>
          <ul className="list-disc pl-5 space-y-2 text-gray-400">
            <li>
              <strong className="text-gray-200">Market Volatility:</strong>{" "}
              Cryptocurrency markets are highly volatile. Past performance of AI
              agents does not guarantee future returns.
            </li>
            <li>
              <strong className="text-gray-200">Smart Contract Risk:</strong>{" "}
              While our code undergoes rigorous testing, interacting with smart
              contracts inherently carries the risk of unforeseen exploits or
              bugs.
            </li>
            <li>
              You acknowledge that utilizing OmniAgents involves financial risk,
              and you agree to use the service at your own discretion.
            </li>
          </ul>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            3. Prohibited Uses
          </h4>
          <p>
            You agree not to exploit the protocol for malicious activities,
            including but not limited to front-running exploits not supported by
            the core engine, sybil attacks against our infrastructure, or
            utilizing the platform for money laundering.
          </p>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            4. Limitation of Liability
          </h4>
          <p>
            Under no circumstances shall OmniAgents, its contributors, or
            affiliates be liable for any direct, indirect, incidental, or
            consequential damages resulting from the use or inability to use the
            protocol.
          </p>
        </div>
      </Modal>

      <Modal
        isOpen={activeModal === "cookies"}
        onClose={() => setActiveModal(null)}
        title="Cookie Settings & Policy"
      >
        <div className="space-y-6">
          <div className="p-4 rounded-xl border border-[#00FFA3]/20 bg-[#00FFA3]/5 flex items-start gap-4">
            <Info className="text-[#00FFA3] flex-shrink-0 mt-1" size={24} />
            <p className="text-sm text-gray-300">
              We value your privacy. OmniAgents utilizes a minimal approach to
              cookies. You can manage your preferences below.
            </p>
          </div>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            Your Preferences
          </h4>

          <div className="space-y-4">
            {/* Essential Cookies */}
            <div className="flex items-center justify-between p-4 rounded-lg bg-white/5 border border-white/10">
              <div>
                <h5 className="text-white font-medium mb-1">
                  Strictly Necessary Cookies
                </h5>
                <p className="text-xs text-gray-400">
                  Required for the dApp to function (e.g., RPC connections,
                  wallet state). Cannot be disabled.
                </p>
              </div>
              <div className="w-12 h-6 bg-[#00FFA3] rounded-full relative opacity-50 cursor-not-allowed">
                <div className="w-4 h-4 bg-black rounded-full absolute right-1 top-1"></div>
              </div>
            </div>

            {/* Analytics Cookies */}
            <div className="flex items-center justify-between p-4 rounded-lg bg-white/5 border border-white/10 hover:border-white/20 transition-colors">
              <div>
                <h5 className="text-white font-medium mb-1">
                  Performance & Analytics
                </h5>
                <p className="text-xs text-gray-400">
                  Helps us understand how the protocol is used so we can improve
                  the interface.
                </p>
              </div>
              {/* Fake Toggle for UI purposes */}
              <button className="w-12 h-6 bg-[#00FFA3] rounded-full relative transition-colors shadow-[0_0_10px_rgba(0,255,163,0.3)]">
                <div className="w-4 h-4 bg-black rounded-full absolute right-1 top-1 transition-transform"></div>
              </button>
            </div>
          </div>

          <div className="pt-4 text-xs text-gray-500">
            For more details, please refer to our full Privacy Policy. By
            continuing to use OmniAgents, you agree to our use of strictly
            necessary cookies.
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={activeModal === "docs"}
        onClose={() => setActiveModal(null)}
        title="Protocol Documentation"
      >
        <div className="space-y-6">
          <div className="flex items-center justify-center p-8 border border-dashed border-white/20 rounded-xl bg-black/30">
            <div className="text-center">
              <Database
                size={40}
                className="text-[#00FFA3] mx-auto mb-4 opacity-50"
              />
              <h4 className="text-xl font-bold text-white mb-2">
                Full Documentation Loading
              </h4>
              <p className="text-gray-400 text-sm max-w-md mx-auto">
                Our comprehensive developer and user documentation (GitBook) is
                currently being finalized for the Phase 1 launch.
              </p>
            </div>
          </div>

          <h4 className="text-white text-lg font-bold mt-8 border-b border-white/10 pb-2">
            Quick Overview
          </h4>
          <p>
            OmniAgents utilizes an off-chain AI decision matrix coupled with
            on-chain execution smart contracts.
          </p>

          <ul className="list-none space-y-4">
            <li className="flex gap-4">
              <div className="w-8 h-8 rounded-lg bg-[#00FFA3]/10 text-[#00FFA3] flex items-center justify-center flex-shrink-0 mt-1">
                1
              </div>
              <div>
                <strong className="text-white block mb-1">
                  The Matrix (AI Layer)
                </strong>
                <span className="text-gray-400 text-sm">
                  Scans mempools, DEX order books, and cross-chain bridges to
                  identify profitable arbitrage, yield farming, or liquidations.
                </span>
              </div>
            </li>
            <li className="flex gap-4">
              <div className="w-8 h-8 rounded-lg bg-[#00FFA3]/10 text-[#00FFA3] flex items-center justify-center flex-shrink-0 mt-1">
                2
              </div>
              <div>
                <strong className="text-white block mb-1">
                  The Relayer (Transport Layer)
                </strong>
                <span className="text-gray-400 text-sm">
                  Validates the risk profile of the identified route and
                  securely transmits the payload to the specific target chain.
                </span>
              </div>
            </li>
            <li className="flex gap-4">
              <div className="w-8 h-8 rounded-lg bg-[#00FFA3]/10 text-[#00FFA3] flex items-center justify-center flex-shrink-0 mt-1">
                3
              </div>
              <div>
                <strong className="text-white block mb-1">
                  The Router (Execution Layer)
                </strong>
                <span className="text-gray-400 text-sm">
                  Smart contracts interact directly with the target protocol,
                  complete the task, and deposit the yield directly to the
                  user's active wallet.
                </span>
              </div>
            </li>
          </ul>
        </div>
      </Modal>

      <style>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes reverse-spin {
          from { transform: rotate(360deg); }
          to { transform: rotate(0deg); }
        }
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
        @keyframes grid-diagonal {
          0% { transform: translate(0, 0); }
          100% { transform: translate(50px, 50px); }
        }
        @keyframes grid-scroll {
          0% { transform: translateY(0); }
          100% { transform: translateY(60px); }
        }
        @keyframes pulse-slow {
          0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.5; }
          50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.8; }
        }
        @keyframes gradient-xy {
          0%, 100% { background-position: 0% 0%; }
          50% { background-position: 100% 100%; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-3px); }
        }
        
        .animate-spin-slow { animation: spin-slow 10s linear infinite; }
        .animate-reverse-spin { animation: reverse-spin 15s linear infinite; }
        .animate-fade-in-up { animation: fade-in-up 0.4s ease-out forwards; }
        .animate-fade-in { animation: fade-in 0.3s ease-out forwards; }
        .animate-shimmer { animation: shimmer 2s infinite; }
        .animate-grid-diagonal { animation: grid-diagonal 1.5s linear infinite; }
        .animate-grid-scroll { animation: grid-scroll 3s linear infinite; }
        .animate-pulse-slow { animation: pulse-slow 4s ease-in-out infinite; }
        .animate-gradient-xy { animation: gradient-xy 10s ease infinite; }
        .animate-float { animation: float 3s ease-in-out infinite; }
        .animate-breathe { animation: breathe 8s ease-in-out infinite; }
        .animate-spin-border { animation: spin-border 2s linear infinite; }
        
        .text-mint-400 { color: #00FFA3; }
        .bg-mint-500 { background-color: #00FFA3; }
        .bg-mint-400 { background-color: #00e592; }
        .bg-mint-900 { background-color: #003320; }
        .border-mint-500 { border-color: #00FFA3; }
        .mask-gradient-b { mask-image: linear-gradient(to top, black 40%, transparent 100%); }
        .clip-corner-br { clip-path: polygon(100% 0, 0 100%, 100% 100%); }
        
        /* Custom Scrollbar for Modals */
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.02);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 255, 163, 0.3);
        }
      `}</style>
    </div>
  );
};

export default App;
